import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { WellsPage } from '../../WellsPage'
import { editorSearchSchema } from '../search-schemas'

// /wells — реальный CRUD-каталог скважин (OSDU Well). Список + редактор,
// открытие редактора через search-параметры (?edit=N / ?new=1), как у
// /fields и /casings — чтобы не размонтировать список при переключении
// list↔editor. Прежний mock-дашборд (/wells/$wellId) ретайрнут вместе с
// data.ts-моком WELLS на этом маршруте.
export const wellsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/wells',
  validateSearch: editorSearchSchema,
  component: WellsRouteComponent,
})

function WellsRouteComponent() {
  const search = wellsRoute.useSearch()
  const navigate = useNavigate()
  return (
    <WellsPage
      wellId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/wells', search: { edit: id } })}
      onCreate={() => navigate({ to: '/wells', search: { new: 1 } })}
      onBack={() => navigate({ to: '/wells', search: {} })}
    />
  )
}
